import { useContext } from 'react';
import { AuthContext, AuthType } from '../context/AuthProvider';


// const useAuth = () => {
//   return useContext(AuthContext) as AuthType;
// };

const useAuth =():AuthType=>{
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export default useAuth;
